﻿<script>
	import { projectSettings } from "../config";
	import { regFormPhone } from "../gtm";

	const scrollTop = () => {
		window.scrollTo({
			top: 0,
			left: 0,
			behavior: "smooth"
		});
	};
</script>

<div class="back-to-top-row no-print" style="position: relative;">
	<button class="back-to-top" on:click|preventDefault={scrollTop}>
		<p class="sc-11567dcf-0 hovjwP">Back to top</p>
		<svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" viewBox="0 0 12 13" name="Back To Top" class="up-arrow"
			><defs
				><style>
					.cls-45 {
						fill: #ff4814;
					}
				</style></defs
			><path
				class="cls-45"
				d="M7.02,12.93h-2.06V3.98L1.93,7.03l-1.42-1.45L5.99,.07l5.5,5.5-1.45,1.45-3.03-3.04V12.93Z"></path
			></svg>
	</button>
</div>

<footer class="no-print">
	<div class="navigation-row">
		<nav>
			<ul>
				<li>
					<a href="https://shine.com.au/contact-us" target="_blank" title="Contact">Contact</a>
				</li>
				<li>
					<a href="https://shine.com.au/resources" target="_blank" title="Resources">Resources</a>
				</li>
				<li>
					<a href="https://shine.com.au/about-us" target="_blank" title="About Us">About Us</a>
				</li>
				<li>
					<a href="https://shine.com.au/media" target="_blank" title="Media">Media</a>
				</li>
				<li>
					<a href="https://shine.com.au/careers" target="_blank" title="Careers">Careers</a>
				</li>
				<li>
					<a href="https://www.shinejustice.com.au/Investors/" target="_blank" title="Shine Justice">
						Shine Justice
						<svg
							xmlns="http://www.w3.org/2000/svg"
							xmlns:xlink="http://www.w3.org/1999/xlink"
							id="Layer_1"
							viewBox="0 0 12 12"
							color="var(--color-white)"
							name="External Link"
							class="external-link-icon"
							style="margin-left: 5px;"
							><defs
								><style>
									.cls-40 {
										fill: none;
									}
									.cls-41 {
										clip-path: url(#clippath15);
									}
									.cls-42 {
										fill: #ddd;
									}
								</style><clipPath id="clippath15"
									><path
										class="cls-40"
										d="M6.06,0V1.74H1.74V10.26H10.26V5.94h1.74v4.32c0,.5-.17,.91-.51,1.24-.34,.33-.75,.5-1.23,.5H1.74c-.49,0-.9-.17-1.23-.51-.34-.34-.51-.75-.51-1.23V1.74c0-.49,.17-.9,.51-1.23,.34-.34,.75-.51,1.23-.51H6.06Zm5.94,0V4.61h-1.74v-1.66l-5.41,5.43-1.22-1.22L9.06,1.74h-1.66V0h4.61Z"
									></path
									></clipPath
								></defs
							><g class="cls-41"><polygon class="cls-42" points="0 0 12 0 12 12 0 12 0 0"></polygon></g
							></svg>
					</a>
				</li>
			</ul>

			<a
				href="tel:{projectSettings.phoneNumber}"
				class="phone"
				on:click={() => regFormPhone(projectSettings.phoneNumber)}>
				<svg
					id="uuid-67d83c8f-d61b-484b-bc31-7c86f891206e"
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 24 24"
					name="Phone"
					class="phone-icon"
					><defs
						><style>
							.uuid-43e75a5b-fff4-4b7c-bda9-4691d537da65 {
								fill: #222222;
							}
							.uuid-43e75a5b-fff4-4b7c-bda9-4691d537da65,
							.uuid-b240d7b9-dab8-4c54-b16c-69264e3373ba {
								fill-rule: evenodd;
							}
							.uuid-b240d7b9-dab8-4c54-b16c-69264e3373ba {
								fill: #ff4814;
							}
						</style></defs
					><path
						id="uuid-4eb7f896-8890-4522-ba60-51e298f63be1"
						class="uuid-b240d7b9-dab8-4c54-b16c-69264e3373ba"
						d="M17.63,24h0c-3.12,0-6.87-2.16-11.17-6.42C3.52,14.65,0,10.34,0,6.47,0,4.87,.56,3.5,1.67,2.39c.01-.01,.02-.02,.03-.03,.1-.09,.11-.1,1.49-1.16l.35-.26c.37-.28,.67-.51,.73-.56,.69-.55,1.69-.5,2.31,.12l3.82,3.82c.61,.61,.69,1.56,.19,2.27l-2.27,2.78,6.67,6.58,2.81-2.23c.73-.52,1.67-.45,2.28,.15l3.41,3.41c.65,.64,.68,1.69,.1,2.38-.12,.19-.33,.49-.71,1.05q-1.01,1.48-1.14,1.61c-1.12,1.12-2.5,1.68-4.1,1.68h0Z"
					></path
					><path
						id="uuid-9318059f-eacc-47d2-baf3-9b8d18d5dd0d"
						class="uuid-43e75a5b-fff4-4b7c-bda9-4691d537da65"
						d="M3.13,3.84c-.72,.72-1.07,1.58-1.07,2.63,0,2.47,2.08,5.9,5.86,9.65,4.85,4.81,7.96,5.83,9.72,5.83h0c1.05,0,1.92-.35,2.65-1.08,.02-.03,.27-.4,.89-1.31,.29-.42,.56-.83,.68-1l-3.02-3.02-3.27,2.6c-.41,.32-.99,.29-1.36-.07l-7.99-7.88c-.38-.37-.41-.97-.07-1.38l2.63-3.21-3.42-3.42c-.14,.11-.33,.26-.55,.42l-.35,.26c-.97,.74-1.22,.93-1.31,1h0Z"
					></path
					></svg>
				<div class="phone-number">
					{projectSettings.phoneNumber}
					<p class="sc-11567dcf-0 hovjwP">TOLL FREE</p>
				</div>
			</a>
		</nav>
	</div>
	<div class="social-ack">
		<div class="social-ack-inner">
			<div class="social-wrap">
				<div class="social">
					<div class="socials-title">
						<p font-size="12px">GET THE LATEST FROM SHINE LAWYERS</p>
					</div>
					<div class="social-icon-wrap">
						<div class="social-icons">
							<a class="social-icon-link" target="_blank" href="https://twitter.com/ShineLawyers">
								<div class="social-icon-border">
									<div class="social-icon-image">
										<img
											src="https://images.ctfassets.net/20mp39y5r2lk/4dmrwlDPwsNAPdOEYrkU0y/8c85c58815833d663f7b4639114fe55d/X.svg?q=80"
											alt="" />
									</div>
								</div>
							</a>
							<a class="social-icon-link" target="_blank" href="https://www.facebook.com/shinelawyers/">
								<div class="social-icon-border">
									<div class="social-icon-image">
										<img
											src="https://images.ctfassets.net/20mp39y5r2lk/7HZ4UruG5CBFzMf9pfcy0J/2dd03165d372551e6007013a8ecb22a6/Facebook.svg"
											alt="" />
									</div>
								</div>
							</a>
							<a
								class="social-icon-link"
								target="_blank"
								href="https://www.linkedin.com/company/shine-lawyers-ltd">
								<div class="social-icon-border">
									<div class="social-icon-image">
										<img
											src="https://images.ctfassets.net/20mp39y5r2lk/2Yng2AsM4SrNDX1QVB37JH/368483dbf45476060ee457e937e458b4/Linkedin.svg"
											alt="" />
									</div>
								</div>
							</a>
							<a class="social-icon-link" target="_blank" href="https://www.youtube.com/@shinelawyers">
								<div class="social-icon-border">
									<div class="social-icon-image">
										<img
											src="https://images.ctfassets.net/20mp39y5r2lk/5jHxQSIzM5yoM2x5TDQEH8/bddf7a23bf0f8786fe356e2d3bfde773/You_Tube.svg"
											alt="" />
									</div>
								</div>
							</a>
							<a class="social-icon-link" target="_blank" href="https://www.instagram.com/shinelawyers">
								<div class="social-icon-border">
									<div class="social-icon-image">
										<img
											src="https://images.ctfassets.net/20mp39y5r2lk/5QUwQfpJTAUXCjQjT1QVE4/89a9395c78356e86a132feaf24545ee8/Instagram.svg"
											alt="" />
									</div>
								</div>
							</a>
						</div>
					</div>
				</div>
			</div>
			<div class="acknowledgement-wrap">
				<div class="acknowledgement">
					<div class="acknowledgement-image">
						<img
							src="https://images.ctfassets.net/20mp39y5r2lk/6H12oG16y1EQUWgOEIapqm/7204c24b9d8ffae40acec925559fd4d8/footer-acknowledgement_of_country.jpg"
							alt=""
							class="sc-7c7e190e-2 deKLj" />
					</div>
					<div class="acknowledgement-text-wrap">
						<div class="acknowledgement-text">
							<p style="font-size: var(--font-size-body);">
								Shine Lawyers would like to acknowledge the traditional custodians of the land on which
								we live and work. We would also like to pay respect to the elders past and present and
								extend that respect to all other Aboriginal people.
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="copy-wrap">
		<div class="copy">
			<nav>
				<ul>
					<li>
						<a target="_blank" href="https://shine.com.au/privacy-policy">Privacy Policy</a>
					</li>
					<li>
						<a target="_blank" href="https://shine.com.au/terms-and-conditions">Terms and Conditions</a>
					</li>
					<li>
						<a target="_blank" href="https://shine.com.au/cookies-policy">Cookies Policy</a>
					</li>
					<li>
						<a target="_blank" href="https://shine.com.au/sitemap">Sitemap</a>
					</li>
				</ul>
				<div class="company">
					<p font-size="var(--font-size-xs)" class="sc-11567dcf-0 eXKRYq">
						Shine Lawyers Pty Ltd | ABN 86 134 702 757
					</p>
					<div class="copyright">
						Copyright {new Date().getFullYear()} Shine Lawyers. All Rights Reserved
					</div>
				</div>
			</nav>
		</div>
	</div>
</footer>

<style>
	.back-to-top-row {
		width: 100%;
		max-width: 1440px;
		padding: 0px 30px;
		margin: 0px auto;
	}

	.back-to-top {
		display: flex;
		flex-direction: row;
		-webkit-box-pack: start;
		justify-content: flex-start;
		-webkit-box-align: center;
		align-items: center;
		height: fit-content;
		color: black;
		z-index: 10;
		font-weight: 600;
		cursor: pointer;
		font-size: var(--font-size-h5);
		padding: 0.5rem 0px;
		left: 0px;
		background-color: white;
		border: none;
	}

	.back-to-top-row p {
		margin: 0;
		margin-right: 5px;
	}

	.back-to-top-row .up-arrow {
		width: 13px;
		height: 13px;
		min-width: 13px;
		min-height: 13px;
	}

	footer {
		background-color: var(--color-black);
		height: fit-content;
		color: white;
		width: 100%;
		display: flex;
		flex-direction: column;
		position: relative;
	}

	.navigation-row {
		background-color: var(--color-black);
	}

	.navigation-row > * {
		display: flex;
		flex-direction: row;
		height: 80px;
	}

	.navigation-row nav {
		width: 100%;
		max-width: 1440px;
		padding: 0px 30px;
		margin: 0px auto;
	}

	.navigation-row nav ul {
		display: flex;
		min-width: 70%;
		height: 100%;
		-webkit-box-pack: start;
		justify-content: flex-start;
		-webkit-box-align: center;
		align-items: center;

		list-style-type: none;
		margin: 0;
		padding: 0;
		/*margin-right: 240px;*/
	}

	.navigation-row nav ul li {
		height: 100%;
		display: flex;
		-webkit-box-align: center;
		align-items: center;
		font-weight: 600;
		font-size: 16px;
		margin-left: 3.5vw;
	}

	.navigation-row nav ul li:first-child {
		margin-left: 0;
	}

	.navigation-row nav ul li a {
		border-bottom: none;
	}

	.navigation-row nav ul li a:hover {
		color: var(--color-primary);
	}

	.navigation-row .phone {
		display: flex;
		-webkit-box-pack: start;
		justify-content: flex-start;
		-webkit-box-align: center;
		align-items: center;
		height: 100%;
		min-width: fit-content;
	}

	.navigation-row .phone .phone-icon {
		width: 1.4rem;
		height: 1.4rem;
		min-width: 1.4rem;
		min-height: 1.4rem;
	}

	.navigation-row .phone .phone-number {
		height: 100%;
		color: var(--color-primary);
		font-size: var(--font-size-h4);
		font-weight: 700;
		display: flex;
		-webkit-box-pack: center;
		justify-content: center;
		flex-direction: column;
		align-items: flex-start;
		margin-left: 10px;
	}

	.navigation-row .phone .phone-number p {
		font-size: var(--font-size-xs);
		color: white !important;
		margin: 0;
	}

	.navigation-row .external-link-icon {
		width: 0.7rem;
		height: 0.7rem;
		min-width: 0.7rem;
		min-height: 0.7rem;
		fill: var(--color-white) !important;
	}

	div.social-ack {
		background-color: var(--color-charcoal);
		border-bottom: 5px solid var(--color-primary);
	}

	div.social-ack > div {
		display: flex;
		flex-direction: row;
		-webkit-box-pack: justify;
		justify-content: space-between;
	}

	div.social-ack-inner {
		display: flex;
		flex-direction: row;
		-webkit-box-pack: justify;
		justify-content: space-between;
		width: 100%;
		max-width: 1440px;
		padding: 0px 30px;
		margin: 0px auto;
	}

	div.social-wrap,
	div.acknowledgement-wrap {
		width: 50%;
	}

	div.social {
		display: flex;
		flex-direction: column;
		-webkit-box-pack: center;
		justify-content: center;
		height: 100%;
	}

	div.social .socials-title p {
		width: max-content;
		color: var(--color-lightGrey);
		font-weight: 600;
		padding-bottom: 10px;
		font-size: 12px;
		margin: 0px;
	}

	div.social-icon-wrap {
		display: flex;
		flex-direction: row;
		-webkit-box-pack: start;
		justify-content: flex-start;
		-webkit-box-align: center;
		align-items: center;
	}

	div.social-icons {
		display: flex;
	}

	a.social-icon-link {
		color: inherit;
		text-decoration: none;
	}

	div.social-icon-border {
		min-height: fit-content;
		width: 45px;
		border: 1px solid var(--color-primary);
		border-radius: 30px;
		display: flex;
		padding: 7px;
		-webkit-box-pack: center;
		justify-content: center;
		background-color: var(--color-black);
		cursor: pointer;
		margin-right: 5px;
	}

	div.social-icon-image {
		position: relative;
		width: var(--size-icon-xs);
		height: var(--size-icon-xs);
	}

	div.social-icon-image img {
		width: 100%;
		height: 100%;
		object-fit: cover;
		vertical-align: initial;
	}

	div.acknowledgement-wrap {
		padding: 20px;
		height: fit-content;
		max-width: 50%;
		display: flex;
		flex-direction: row;
		justify-content: space-evenly;
	}

	div.acknowledgement {
		display: flex;
		flex-direction: row;
		-webkit-box-pack: center;
		justify-content: center;
		-webkit-box-align: center;
		align-items: center;
	}

	div.acknowledgement-image {
		position: relative;
		width: 150px;
		height: 85px;
	}

	div.acknowledgement-image img {
		/*		width: 100%;*/
		height: 100%;
		object-fit: contain;
	}

	div.acknowledgement-text-wrap {
		width: 100%;
		margin-left: 50px;
	}

	div.acknowledgement-text {
		white-space: pre-line;
	}

	div.acknowledgement-text p {
		margin-top: 0px;
		font-size: 16px !important;
		color: var(--color-soft) !important;
	}

	div.copy-wrap {
		background-color: var(--color-lightGrey);
		text-align: center;
	}

	div.copy {
		width: 100%;
		max-width: 1440px;
		padding: 0px 30px;
		margin: 0px auto;
	}

	div.copy nav {
		height: fit-content;
		width: 100%;
		color: var(--color-black);
		display: flex;
		-webkit-box-align: center;
		align-items: center;
		-webkit-box-pack: justify;
		justify-content: space-between;
		padding: 10px 10px 10px 0px;
		font-size: var(--font-size-xs);
	}

	div.copy nav ul {
		display: flex;
		-webkit-box-pack: center;
		justify-content: center;
		-webkit-box-align: center;
		align-items: center;
		min-width: fit-content;
		margin: 0;
		padding: 0;
		list-style: none;
	}

	div.copy nav ul li {
		margin-right: 30px;
		min-width: fit-content;
	}

	div.copy nav ul li a {
		border-bottom: none;
	}

	div.copy .company {
		display: flex;
		-webkit-box-pack: justify;
		justify-content: space-between;
		width: 100%;
	}

	div.copy .company p {
		font-size: var(--font-size-xs);
		margin: 0px;
	}

	div.copy .company .copyright {
		margin-right: 30px;
	}

	.navigation-row nav ul li a:hover,
	div.copy a:hover {
		color: var(--color-primary);
	}

	@media (max-width: 1024px) {
		div.social {
			-webkit-box-pack: center;
			justify-content: center;
			align-items: flex-start;
		}

		div.social-wrap {
			width: unset;
		}

		div.social-icon-wrap {
			flex-direction: column;
			-webkit-box-pack: center;
			justify-content: center;
			align-items: flex-start;
		}

		div.acknowledgement-wrap {
			flex-direction: column;
			margin-left: 0px;
			width: unset;
			max-width: unset;
		}

		div.acknowledgement {
			flex-direction: column;
			max-width: 100%;
		}

		div.acknowledgement-text-wrap {
			flex-direction: column;
			max-width: 100%;
			margin-left: 0px;
			text-align: center;
		}

		div.copy nav {
			flex-direction: column;
			padding: 0px;
		}

		div.copy nav ul {
			margin-top: 10px;
			flex-wrap: wrap;
		}

		div.copy nav ul li {
			margin: 0 10px;
		}

		div.copy .company {
			-webkit-box-pack: center;
			justify-content: center;
			-webkit-box-align: center;
			align-items: center;
			flex-direction: column;
		}

		div.copy .company p {
			margin-top: 10px;
		}

		div.copy .company .copyright {
			margin-right: 0;
			margin-top: 10px;
		}
	}

	@media (max-width: 768px) {
		:root {
			--size-icon-xs: 18px;
			--size-icon-sm: 30px;
			--size-icon-md: 38px;
			--size-icon-lg: 75px;
			--size-icon-liveChat: 26px;
			--size-icon-xl: 150px;
			--size-icon-xxl: 220px;
			--height-header: 60px;
			--font-size-homepage: 46px;
			--font-size-h1: 40px;
			--font-size-h2: 30px;
			--font-size-h3: 22px;
			--font-size-h4: 20px;
			--font-size-h5: 18px;
			--font-size-h6: 11px;
			--font-size-sm: 0.7rem;
			--font-size-xs: 0.6rem;
		}

		.navigation-row > * {
			width: 100%;
			flex-direction: column-reverse;
			height: fit-content;
			-webkit-box-pack: center;
			justify-content: center;
			-webkit-box-align: center;
			align-items: center;
		}

		.navigation-row nav ul {
			width: 100%;
			flex-direction: column;
		}

		.navigation-row nav ul li {
			margin-bottom: 20px;
			margin-left: 0;
		}

		.navigation-row nav ul li:first-child {
			margin-left: 0;
		}

		.navigation-row .phone {
			width: fit-content;
			margin: 20px 0px;
		}
	}

	@media (max-width: 600px) {
		:root {
			--size-icon-xs: 18px;
			--size-icon-sm: 30px;
			--size-icon-md: 38px;
			--size-icon-lg: 75px;
			--size-icon-liveChat: 22px;
			--size-icon-xl: 150px;
			--size-icon-xxl: 220px;
			--font-size-homepage: 36px;
			--font-size-h1: 30px;
			--font-size-h2: 26px;
			--font-size-h3: 20px;
			--font-size-h4: 20px;
			--font-size-h5: 18px;
			--font-size-h6: 11px;
			--font-size-sm: 0.7rem;
			--font-size-xs: 0.6rem;
			--spacing-section: 40px;
		}

		div.social-ack > div {
			flex-direction: column;
		}

		div.social-ack-inner {
			padding: 15px;
		}

		div.social-wrap {
			width: 100%;
		}

		div.social {
			-webkit-box-pack: center;
			justify-content: center;
			-webkit-box-align: center;
			align-items: center;
			padding-top: 10px;
			margin-left: 0px;
		}

		div.social .socials-title {
			width: 100%;
			text-align: center;
		}

		div.social .socials-title p {
			width: 100%;
			text-align: center;
		}

		div.social-icon-wrap {
			-webkit-box-pack: center;
			justify-content: center;
			padding-top: 10px;
		}

		div.social-icons {
			-webkit-box-pack: justify;
			justify-content: space-between;
			width: 100%;
		}
	}
</style>
